import {AxiosInstance, AxiosResponse} from 'axios';
import {VisibleDays} from '../report/types';

export interface ITimeReportV2Api {
    get<T>(
        from: string,
        to: string,
        employeeIds: number[],
        projectIds: number[],
        projectTypeIds: number[],
        showAbsences: boolean
    ): Promise<AxiosResponse<T>>;
    getDaily<T>(
        from: string,
        to: string,
        employeeIds: number[],
        projectIds: number[],
        projectTypeIds: number[],
        visibleDays: VisibleDays,
        showAbsences: boolean
    ): Promise<AxiosResponse<T>>;
}

const appendArrayParams = (params: URLSearchParams, name: string, values: number[]): void => {
    values.forEach((value) => params.append(name, String(value)));
};

export default class TimeReportV2Api implements ITimeReportV2Api {
    private readonly _axiosInstance: AxiosInstance;
    private readonly _controller = 'time-report';

    constructor(axiosInstance: AxiosInstance) {
        this._axiosInstance = axiosInstance;
    }

    async get<T>(
        from: string,
        to: string,
        employeeIds: number[],
        projectIds: number[],
        projectTypeIds: number[],
        showAbsences: boolean
    ): Promise<AxiosResponse<T>> {
        const params = this.buildParams(from, to, employeeIds, projectIds, projectTypeIds, showAbsences);
        return await this._axiosInstance.get<T>(`${this._controller}?${params.toString()}`);
    }

    async getDaily<T>(
        from: string,
        to: string,
        employeeIds: number[],
        projectIds: number[],
        projectTypeIds: number[],
        visibleDays: VisibleDays,
        showAbsences: boolean
    ): Promise<AxiosResponse<T>> {
        const params = this.buildParams(from, to, employeeIds, projectIds, projectTypeIds, showAbsences);
        params.set('visibleDays', String(visibleDays));
        return await this._axiosInstance.get<T>(`${this._controller}/daily?${params.toString()}`);
    }

    private buildParams(
        from: string,
        to: string,
        employeeIds: number[],
        projectIds: number[],
        projectTypeIds: number[],
        showAbsences: boolean
    ): URLSearchParams {
        const params = new URLSearchParams({
            from,
            to,
            showAbsences: String(showAbsences),
        });
        appendArrayParams(params, 'employeeIds', employeeIds);
        appendArrayParams(params, 'projectIds', projectIds);
        appendArrayParams(params, 'projectTypeIds', projectTypeIds);
        return params;
    }
}
